'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {

    $('.hp__our-books [data-carousel]', this).slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        infinity: false
    });

    $('.carousel-base [data-carousel]', this).slick({
        slidesToShow: 6,
        slidesToScroll: 6,
        dots: false,
        prevArrow: '<span class="arrow icon-arrow-big-left"></span>',
        nextArrow: '<span class="arrow icon-arrow-big-right"></span>',
        responsive: [{
            breakpoint: 1600,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5
            }
        }, {
            breakpoint: 1400,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }, {
            breakpoint: 1160,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }]
    });

    // HP teaser
    var $hpTeaserCarousel = $('#hpTeaser', document);
    if ($hpTeaserCarousel.length && !$hpTeaserCarousel.hasClass('slick-initialized')) {

        var setBackgroundImage = function setBackgroundImage($elm) {
            $elm.each(function () {
                var element = this;
                if (element.classList.contains('h-t__bg--mobile')) element.style.display = (0, _linksoftAlbatros.isMaxWidth)('sm') ? 'block' : 'none';else if (element.classList.contains('h-t__bg--desktop') && element.parentElement.querySelector('.h-t__bg--mobile')) element.style.display = (0, _linksoftAlbatros.isMaxWidth)('sm') ? 'none' : 'block';

                element.style.backgroundImage = 'url(' + element.dataset.bg + ')';
            });
        };

        $hpTeaserCarousel.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            var $nextSlide = $('a', slick.$slides.eq(nextSlide));

            // prevent click by dots
            if ($nextSlide.attr('src') === undefined) {
                setBackgroundImage($nextSlide);
            }

            // set bg for next invisble one for smooth switching
            setBackgroundImage($('a', slick.$slides.eq(nextSlide + 1)));
        });

        // first init
        $hpTeaserCarousel.on('init', function (e, slick) {

            // make first image load first!
            setBackgroundImage($('a', slick.$slides.eq(0)));

            // prevent image blink
            if (slick.$slides.length > 1) {
                $('.slick-cloned', $hpTeaserCarousel).each(function () {
                    setBackgroundImage($('a', this));
                });

                for (var i = 0; i < 2; ++i) {
                    setBackgroundImage($('a', slick.$slides.eq(i)));
                }
            } else {
                // init background when there are just 1 item
                setBackgroundImage($('a', this));
            }
        });

        $hpTeaserCarousel.slick({
            dots: false,
            autoplay: true,
            autoplaySpeed: 7000,
            prevArrow: '<button class="slick-prev"></button>',
            nextArrow: '<button class="slick-next"></button>',
            appendArrows: $hpTeaserCarousel.parent().next()
        });
    }
};

var _linksoftAlbatros = require('linksoft-albatros');

var $ = require('jquery');
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/carousels.js
// module id = 596
// module chunks = 0